import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'

import './plugins/element.js'
import './plugins/zhiwi.js'
import router from './router'

import Print from 'vue-print-nb'
Vue.use(Print)

import store from './store'

//编辑器
import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'
// 复制文本
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
Vue.use(QuillEditor)



Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
